<div class="container-fluid p-0 sticky-top scroll">
        
<div id="loader" *ngIf="enableLoader"></div>
<div *ngIf="!enableLoader">
<div class="mb-0 py-4 border-bottom" style="background: #F8F9FA;">
    <div class="container ">
    <a class="strong  text-primary" (click)="backToBatchesScreeningList()">< {{  'home.vms.back' | cxTranslate }}</a>
</div>
</div>
<div class="mb-0 py-4 border-bottom" style="background: #F8F9FA;">
    <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <h6 class="pt-2 pb-2" *ngIf="batchesScreendetails?.screeningStatusCode == 'NEW'"><span
                            class="badge badge-blue badge-set">{{batchesScreendetails.screeningStatus}}</span></h6>
                    <h6 class="pt-2 pb-2" *ngIf="batchesScreendetails?.screeningStatusCode == 'INPROGRESS'"><span
                            class="badge badge-color badge-set">{{batchesScreendetails.screeningStatus}}</span></h6>
                    <h6 class="pt-2 pb-2" *ngIf="(batchesScreendetails?.screeningStatusCode == 'ASSIGNED' || batchesScreendetails?.screeningStatus == 'ARCHIVED')"><span
                            class="badge badge-success badge-set">{{batchesScreendetails.screeningStatus }}</span></h6>
                            <h6 class="pt-2 pb-2" *ngIf="batchesScreendetails?.screeningStatusCode == 'COMPLETED'"><span
                                class="badge badge-black badge-set">{{batchesScreendetails.screeningStatus }}</span></h6>
                </div>
               
                <div class="col-md-2 d-none d-md-block d-lg-block">
                    <p class="small strong text-secondary mb-2 text-nowrap">{{  'batches.screeningCompleted' | cxTranslate }}</p>
                    <div class="btn-group btn-group-sm btn-group-toggle " data-toggle="buttons">
                        <label style="min-height: min-content; font-size: small; line-height: 30px; width: 60px;" id="yes" class="btn m-0 border1 text-secondary "
                        [ngClass]="batchesScreendetails.screeningCompleted==true? ' disabled-highlight ':checkCustomClearenceFlag==true?'active_yes':''"
                            (click)="checkBatchCompleted('yes')">
                            <input type="radio"  name="options" id="{{'optionyes'}}"
                                [disabled]="checkCustomClearenceFlag==true"
                                class="h6 btn btn-block btn-light m-0 border1 ">{{  'batches.YES' | cxTranslate }}</label>
                        <label style="min-height: min-content; font-size: small; line-height: 30px; width: 60px;" id="no" class="btn m-0 border1 " 
                        [ngClass]="batchesScreendetails.screeningCompleted==false && checkCustomClearenceFlag==false? 'active_no':batchesScreendetails.screeningCompleted==false && checkCustomClearenceFlag==false?'':'disabled'"  
                            (click)="checkBatchCompleted('no')">
                            <input type="radio"  name="options" id="{{'optionno'}}"
                                [disabled]="checkCustomClearenceFlag==true"
                                class="h6 btn btn-block btn-light m-0 border1">{{  'batches.NO' | cxTranslate }}</label>
            
                    </div>
                </div>
                <div class="col-md-2 d-none d-md-block d-lg-block" style="padding-top: 1rem !important;margin-left: -1rem !important">
                        <div class="d-none d-lg-block">
                            <div class="d-flex">
                            <a (click)="donwloadReport(section == 'portside'?'screening_report':'bonded_warehouse_screening_report')" class="mr-2 mt-2 text-nowrap" >{{'shipment.Export' | cxTranslate}}</a>
                            <button type="button" (click)="donwloadReport(section == 'portside'?'screening_report':'bonded_warehouse_screening_report')" class="float-right btnheight d-none d-sm-block btn btn border1 dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false"><img src="./images/download_report.svg" alt="customlogo" width="25px" height="25px"> &nbsp;
                            {{'shipment.Export' | cxTranslate}}
                          </button>                    
                          <!-- <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                            <a class="dropdown-item" (click)="donwloadReport('singleScreeningReport')" >{{'shipment.batchesreport' | cxTranslate}}</a>
                          </div> -->
                        </div>
                          </div>
                </div>
                  <div class="col-md-4">
                        <div *ngIf="(batchesScreendetails?.screeningStatusCode == 'COMPLETED' && isAgentInvoiceActive === 'true')" class="d-flex align-items-center">
                        <button
                            class="btn btn-sm strong btn-primary border rounded btnheight pl-3 pr-3 ml-3 text-nowrap"
                            (click)="openPortInvoices(batchesScreendetails)">{{'shipment.invoice.AttachScreeningInvoices' |
                            cxTranslate}}</button>
                    </div>
                </div>
            </div>
        <div class=" ">
            <h2 class="h4 bold">{{batchesScreendetails.batchId}}</h2>
            <h2 class="h4 mb-4 text-secondary">{{batchesScreendetails.vesselName}}</h2>
        </div>
        <div class="row d-flex ml-0 mr-0">
            <div class="col-sm-6">
                <div class="row">
                    <div class="d-none d-md-block d-lg-block  col-sm-5 pl-0">
                        <p class="small strong text-secondary mb-2">{{ 'batches.Dischargeport' | cxTranslate }}</p>
                        <h4 class="h5 bold">{{batchesScreendetails.portName?batchesScreendetails.portName:'--'}}</h4>
                    </div>
                    <div class="d-none d-md-block d-lg-block  col-sm-4 pl-0">
                        <p class="small strong text-secondary mb-2">{{ 'batches.material' | cxTranslate }}</p>
                        <h4 class="h5 bold">{{batchesScreendetails.productName?batchesScreendetails.productName:'--'}}</h4>
                    </div>
                
                    <div class="d-none d-md-block d-lg-block  col-sm-3 pl-0">
                        <p class="small strong text-secondary mb-2"> {{ 'batches.quantity' | cxTranslate }}</p>
                        <h4 class="h5 bold">{{batchesScreendetails.quantity}}</h4>
                    </div>
                   
                </div>
            </div>
            <div class="col-sm-6">
                <div class="row">
                    <div class="d-none d-md-block d-lg-block  col-sm-3 pl-0">
                        <p class="small strong text-secondary mb-2">{{ 'batches.screenedNblu' | cxTranslate }} </p>
                        <h4 class="h5 bold">{{batchesScreendetails.screenedNblluQty}}</h4>
                    </div>
                <div class="d-none d-md-block d-lg-block  col-sm-3 ">
                    <div class="small strong text-secondary mb-2"> {{ 'batches.actualNbslqty' | cxTranslate }}</div>
                    <div class="h5 bold">{{batchesScreendetails.actualNbslQty}}</div>
                </div>
                <div class="d-none d-md-block d-lg-block  col-sm-3 ">
                    <div class="small strong text-secondary mb-2"> {{ 'batches.actualNbsfQty' | cxTranslate }}</div>
                    <div class="h5 bold">{{batchesScreendetails.actualNbsfQty}}</div>
                </div>
                <div class="d-none d-md-block d-lg-block  col-sm-3 ">
                    <div class="small strong text-secondary mb-2">{{ 'batches.NbsfNbllration' | cxTranslate }}</div>
                    <div class="h5 bold">{{batchesScreendetails.nbsfNblluRatio}} %</div>
                </div>
            </div>
            </div>           
        
        </div>
        <!--mobile view-->
        <div class=" d-lg-none">
            <div class="row">
            <div class="col-12">
                <div class="small strong text-secondary mb-2">{{  'home.vms.material' | cxTranslate }}</div>
                <div class="h5 bold">{{batchesScreendetails.productName?batchesScreendetails.productName:'--'}}</div>
            </div>
            </div>
            <div class="row mt-3">
            <div class="col-6">
                <div class="small strong text-secondary mb-2">{{ 'batches.Dischargeport' | cxTranslate }}</div>
                <div class="h5 bold">{{batchesScreendetails.portName?batchesScreendetails.portName:'--'}}</div>
            </div>

            <div class="col-6">
                <div class="small strong text-secondary mb-2">{{ 'batches.quantity' | cxTranslate }} </div>
                <div class="h5 bold">{{batchesScreendetails.quantity}}</div>
            </div>
            </div>
            <div class="row mt-3" >
            <div class="col-6">
                <div class="small strong text-secondary mb-2">{{ 'batches.screenedNblu' | cxTranslate }}  </div>
                <div class="h5 bold">{{batchesScreendetails.screenedNblluQty}}</div>
            </div>
            <div class="col-6">
                <div class="small strong text-secondary mb-2">{{ 'batches.actualNbslqty' | cxTranslate }}</div>
                <div class="h5 bold">{{batchesScreendetails.actualNbslQty}}</div>
            </div>
            </div>
            <div class="row mt-3" >
            <div class="col-6">
                <div class="small strong text-secondary mb-2">{{ 'batches.actualNbsfQty' | cxTranslate }}</div>
                <div class="h5 bold">{{batchesScreendetails.actualNbsfQty}}</div>
            </div>
            <div class="col-6">
                <div class="small strong text-secondary mb-2">{{ 'batches.NbsfNbllration' | cxTranslate }}</div>
                <div class="h5 bold">{{batchesScreendetails.nbsfNblluRatio}} %</div>
            </div>
            </div>
           
                       
        
        </div>
        <div class="d-flex  d-lg-none justify-content-between mt-3 ">
            <p class="small strong text-secondary mb-2 text-nowrap">{{ 'batches.screeningCompleted' | cxTranslate }}</p>
            <div class="btn-group btn-group-sm btn-group-toggle  col-7" data-toggle="buttons">
            <label  id="yes" class="btn m-0 border1 text-secondary button-size"
            [ngClass]="batchesScreendetails.screeningCompleted==true? ' disabled-highlight ':checkCustomClearenceFlag==true?'active_yes':''"
                (click)="checkBatchCompleted('yes')">
                <input type="radio"  name="options" id="{{'optionyes'}}"
                [disabled]="checkCustomClearenceFlag==true"
                class="h6 btn btn-block btn-light m-0 border1 ">{{  'batches.YES' | cxTranslate }}</label>
            <label  id="no" class="btn m-0 border1  button-size" [ngClass]="batchesScreendetails.screeningCompleted==false && checkCustomClearenceFlag==false? 'active_no':batchesScreendetails.screeningCompleted==false && checkCustomClearenceFlag==false?'':'disabled'"
                (click)="checkBatchCompleted('no')">
                <input type="radio"  name="options" id="{{'optionno'}}"
                [disabled]="checkCustomClearenceFlag==true"
                class="h6 btn btn-block btn-light m-0 border1">{{  'batches.NO' | cxTranslate }}</label>
        
            </div>
        </div>
       
    <!--mobile view end-->

    </div>
</div>

<div class="container py-4 pl-0">
    <div class="d-none d-lg-block">
        <div class="row d-flex ml-0 mr-0">
            <div class="col-sm-12 col-md-12">
                <div class="d-flex justify-content-between">
                    <div class="col-md-9">
                        <h5 class="small bold text-secondary">{{  'batches.attatchments' | cxTranslate }} <span *ngIf="batchesScreendetails.screeningDocuments.length>0">({{batchesScreendetails.screeningDocuments.length}})</span> <span class="bold" *ngIf="batchesScreendetails.screeningDocuments.length==0">(0)</span></h5>
                        <span  class="text-secondary " *ngIf="batchesScreendetails.screeningDocuments.length==0">{{  'batches.noFilesAttached' | cxTranslate }} </span>
                        <span class="mt-2" *ngIf="batchesScreendetails.screeningDocuments && batchesScreendetails.screeningDocuments.length >= 1" >
                            <span *ngFor="let attachment of batchesScreendetails.screeningDocuments">
                                <i  class="mt-1 mr-1 fas fa-file-alt text-primary"></i>
                                <a target="_blank" class="ml-1 mb-0 semi-bold attachment fw-600 shadow-none" href="{{attachment.downloadURL}}">
                                    <small  class="font-weight-bold text-primary">{{attachment.documentName}}</small>
                                </a> &nbsp;
                            </span>
                        </span>
                        <span class="ml-3"><a class="text-blue text-decoration-underline" (click)="goToAttachment()">{{  'batches.addFiles' | cxTranslate }}</a></span>
                       
                
                    </div>
                    <div class="col-md-3">
                        <button class="btn border bold h-40 mx-1 " [disabled]="batchesScreendetails.screeningCompleted == true" *ngIf="!editAllBtnFlag" (click)="editAll(form)">{{  'batches.editAllEntries' | cxTranslate }}</button>
                        <button class="btn border bold h-40 mx-1 " *ngIf="editAllBtnFlag" (click)="saveAll(form)">{{  'batches.saveAllEntries' | cxTranslate }}</button>
                        <button class="btn btn-primary border bold h-40 mx-1 " [disabled]="batchesScreendetails.screeningCompleted == true" (click)="addScreening('')">{{  'batches.addScreeningEntry' | cxTranslate }}</button>
                    </div>
                    
                </div>
                    
                <!--formArray implemented-->
                <form [formGroup]="form" *ngIf="!enableLoader">
                    <div class="border rounded p-4 my-3" style="background: #F8F9FA;"
                     formArrayName="batchScreeningItemRequest" *ngFor="let screeningForm of batchScreeningItemRequest.controls; let i = index">
                        <div [formGroup]="screeningForm">
                            <div class="d-flex  mt-3"> 
                                <div class="cust_col_7 text-nowrap">
                                    <p class="small  text-secondary mb-2"> {{  'batches.screeningDate' | cxTranslate }}<span class="text-danger">*</span></p>
                                    <input class="form-control custom_disabled_label" formControlName="screeningEntryDate" *ngIf="screeningFormTemp[i].editScreeningThisFlag==false" > 
                                    <div class="d-flex date-select" *ngIf="screeningFormTemp[i].editScreeningThisFlag==true">
                                        <div class="input-group" >
                                          <input
                                          class="form-control"
                                          placeholder="DD/MM/YYYY"
                                          name="dt_{{i}}"                         
                                          ngbDatepicker
                                          #d="ngbDatepicker"
                                          formControlName="screeningEntryDate" 
                                          id="screeningEntryDate"                    
                                          required  
                                          (click)="d.toggle()"       
                                        />
                                        </div>
                                        <i class="far pickup-calendar" (click)="d.toggle()" ><img src="/images/calendar.svg"   alt="customlogo" width="18px" height="18px" class="" ></i>
                                      </div>
                                      <div class="text-danger" *ngIf="screeningFormTemp[i].reqErrorFlag">{{'batches.thisFieldRequired'| cxTranslate}}</div>
                                                                     
                                </div>
                                <div class="cust_col_7 text-nowrap">      
                                    <p class="small  text-secondary mb-2">{{ 'batches.plannedNblluQty' | cxTranslate }}</p>              
                                    <input class="form-control custom_disabled_label" formControlName="plannedNblluQty" appAllowNegativeDecimalNumber 
                                    [beforeDecimal]="6"  [afterDecimal]="3" >               
                                  </div>
                              
                                <div class="cust_col_7 text-nowrap">
                                    <p class="small  text-secondary mb-2"> {{  'batches.actualNbslqty' | cxTranslate }}</p>            
                                    <input id="actualNbslQty" name="actualNbslQty" formControlName="actualNbslQty" appAllowNegativeDecimalNumber
                                    [beforeDecimal]="6" 
                                    [afterDecimal]="3" class="form-control custom_disabled_label">
                                </div>

                                <div class="cust_col_7 text-nowrap">
                                    <p class="small  text-secondary mb-2">{{  'batches.actualNbsfQty' | cxTranslate }}</p>
                                    <input id="actualNbsfQty" name="actualNbsfQty" formControlName="actualNbsfQty" appAllowNegativeDecimalNumber
                                    [beforeDecimal]="6" 
                                    [afterDecimal]="3" class="form-control custom_disabled_label">
                                </div>
                                <div class="cust_col_7 text-nowrap">
                                    <p class="small  text-secondary mb-2"> {{  'batches.screenedNblu' | cxTranslate }}</p>
                                    <input class="form-control custom_disabled_label" id="screenedNblluQty" name="screenedNblluQty" formControlName="screenedNblluQty">
                                </div>
                                <div class="cust_col_7 text-nowrap">
                                    <p class="small  text-secondary mb-2"> {{  'batches.nbslLocation' | cxTranslate }}</p>
                                    <input id="nbslLoc" name="nbslLoc" formControlName="nbslLoc"  
                                    class="form-control custom_disabled_label">
                                </div>
                                <div class="cust_col_7 text-nowrap">
                                    <p class="small  text-secondary mb-2"> {{  'batches.nbsfLocation' | cxTranslate }}</p>
                                    <input id="nbsfLoc" name="nbsfLoc" formControlName="nbsfLoc" 
                                        class="form-control custom_disabled_label">
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="cust_col_7">
                                    <p class="small  text-secondary mb-2"> {{  'batches.NbsfNbllration' | cxTranslate }}</p>
                                    <input class="form-control custom_disabled_label" id="nbslNbsfRatio" name="nbslNbsfRatio" formControlName="nbslNbsfRatio">

                                </div>
                                <div class="cust_wid_85">
                                    <p class="small  text-secondary mb-2">{{  'batches.remark' | cxTranslate }} </p>
                                    <input id="screeningRemarks" name="screeningRemarks" formControlName="screeningRemarks" 
                                        class="form-control custom_disabled_label">
                                </div>
                            </div>             
                         
                            <div class="d-flex mt-3 justify-content-end"  *ngIf="screeningFormTemp[i].editScreeningThisFlag==true ">
                                <button class="btn-primary border bold h-40 float-end"  (click)="saveScreeningRecord(screeningForm,i)"> {{  'batches.save' | cxTranslate }}</button>
                            </div>  
                            <div  *ngIf="screeningFormTemp[i].editScreeningThisFlag==false">
                                <hr>
                                <div class="d-flex justify-content-between">
                                    <div class=" d-flex justify-content-between">
                                        <div class="col_3 text-nowrap px-3">
                                            <p id="entryDate" class="small text-secondary mb-2 "  name="entryDate" >{{  'batches.entryDate' | cxTranslate }}: {{screeningForm.controls.entryDate.value}}</p><!--<p ></p> -->
                                        </div>
                                        <div class="col_3 text-nowrap px-3">
                                            <p class="small  text-secondary mb-2" id="lastUpdatedOn" name="lastUpdatedOn" >{{  'batches.updatedOn' | cxTranslate }}: {{screeningForm.controls.lastUpdatedOn.value}}</p>
                                        </div>
                                        <div class="col_3 text-nowrap px-3">
                                            <p class="small  text-secondary mb-2" id="lastUpdatedBy" name="lastUpdatedBy" >{{  'batches.lastUpdatedBy' | cxTranslate }}: {{screeningForm.controls.lastUpdatedBy.value}}</p>
                                        </div>
                                    </div>
                                    <button class="btn btn-secondary border bold h-40" [disabled]="batchesScreendetails.screeningCompleted == true" (click)="editScreeningRecord(screeningForm,i)">{{  'batches.edit' | cxTranslate }}</button>
                                </div>  
                            </div> 
                        </div>       
                    </div>                    
                </form>
             </div>
        </div>
    </div>


    <!--screening entries mobile  view-->
    <div class="d-lg-none ">
        <div class="row d-flex ml-0 mr-0">
            <div class="col-sm-12 col-md-12">
                <div class="">
                    <div class="col_12 text-nowrap">
                        <h5 class="small bold text-secondary pl-4">{{  'batches.attatchments' | cxTranslate }} <span *ngIf="batchesScreendetails.screeningDocuments.length>0">({{batchesScreendetails.screeningDocuments.length}})</span> <span class="bold" *ngIf="batchesScreendetails.screeningDocuments.length==0">(0)</span></h5>
                        <div class="d-flex"><p class="text-secondary pl-4" *ngIf="batchesScreendetails.screeningDocuments.length === 0">{{  'batches.noFilesAttached' | cxTranslate }}</p>
                        <div  class="mt-2 pl-4"  *ngIf="batchesScreendetails.screeningDocuments && batchesScreendetails.screeningDocuments.length >= 1" >
                            <div class="d-flex" *ngFor="let attachment of batchesScreendetails.screeningDocuments">
                                <i  class="mt-1 mr-1 fas fa-file-alt text-primary"></i>
                                <a target="_blank" class="ml-1 mb-0 semi-bold attachment fw-600 shadow-none" href="{{attachment.downloadURL}}">
                                    <small  class="font-weight-bold text-primary">{{attachment.documentName}}</small>
                                </a>
                            </div>
                        </div>
                        <span class="ml-3"><a class="text-blue text-decoration-underline" (click)="goToAttachment()">{{  'batches.addFiles' | cxTranslate }}</a></span>
                        </div>
                
                    </div>
                    <div class="col_12">
                        <button class="btn border bold h-40 mx-1 " *ngIf="!editAllBtnFlag"  [disabled]="batchesScreendetails.screeningCompleted == true" (click)="editAll(form)">{{  'batches.editAllEntries' | cxTranslate }}</button>
                        <button class="btn border bold h-40 mx-1 " *ngIf="editAllBtnFlag" (click)="saveAll(form)">{{  'batches.saveAllEntries' | cxTranslate }}</button>
                        <button class="btn btn-primary border bold h-40 mx-1 "  [disabled]="batchesScreendetails.screeningCompleted == true" (click)="addScreening('')">{{  'batches.addScreeningEntry' | cxTranslate }}</button>
                    </div>
                    
                </div>
                    
                <!--formArray implemented-->
                <form [formGroup]="form" *ngIf="!enableLoader">
                    <div class="border rounded p-4 my-3" style="background: #F8F9FA;"
                        formArrayName="batchScreeningItemRequest" *ngFor="let screeningForm of batchScreeningItemRequest.controls; let i = index">
                        <div [formGroup]="screeningForm">
                           <div class="row mt-3">
                              <div class="col-6 text-nowrap">
                                 <p class="small text-secondary mb-2">{{ 'batches.screeningDate' | cxTranslate }}<span class="text-danger">*</span></p>
                                 <input class="form-control custom_disabled_label" formControlName="screeningEntryDate" *ngIf="screeningFormTemp[i].editScreeningThisFlag==false" > 
                                 <div class="d-flex date-select">
                                    <div class="input-group ">
                                        <input
                                           class="form-control"
                                           placeholder="DD/MM/YYYY"
                                           name="dt_{{i}}"                         
                                           ngbDatepicker
                                           #d="ngbDatepicker"
                                           formControlName="screeningEntryDate" 
                                           id="screeningEntryDate"      
                                           required  
                                           (click)="d.toggle()"       
                                        />
                                    </div>
                                    <i class="far pickup-calendar ms-2 flex-shrink-0" (click)="d.toggle()">
                                        <img src="/images/calendar.svg" alt="customlogo" width="18px" height="18px" class="">
                                    </i>
                                 </div>
                                 <div class="text-danger" *ngIf="screeningForm.controls.screeningEntryDate.touched && screeningForm.controls.screeningEntryDate.errors?.required">{{'batches.thisFieldRequired'| cxTranslate}}</div>
                              </div>
                                <div class="col-6 text-nowrap">      
                                    <p class="small  text-secondary mb-2">{{ 'batches.plannedNblluQty' | cxTranslate }}</p>              
                                    <input class="form-control custom_disabled_label" formControlName="plannedNblluQty" appAllowNegativeDecimalNumber 
                                    [beforeDecimal]="6"  [afterDecimal]="3" >               
                                  </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-6 text-nowrap">
                                    <p class="small  text-secondary mb-2"> {{  'batches.actualNbslqty' | cxTranslate }}</p>            
                                    <input id="actualNbslQty" name="actualNbslQty" formControlName="actualNbslQty" appAllowNegativeDecimalNumber
                                    [beforeDecimal]="6" 
                                    [afterDecimal]="3" class="form-control custom_disabled_label">
                                </div>

                                <div class="col-6 text-nowrap">
                                    <p class="small  text-secondary mb-2">{{  'batches.actualNbsfQty' | cxTranslate }}</p>
                                    <input id="actualNbsfQty" name="actualNbsfQty" formControlName="actualNbsfQty" appAllowNegativeDecimalNumber
                                    [beforeDecimal]="6" 
                                    [afterDecimal]="3" class="form-control custom_disabled_label">
                                </div>
                            </div>
                              <div class="row mt-3">
                                <div class="col-6 text-nowrap">
                                    <p class="small  text-secondary mb-2"> {{  'batches.screenedNblu' | cxTranslate }}</p>
                                    <input class="form-control custom_disabled_label" id="screenedNblluQty" name="screenedNblluQty" formControlName="screenedNblluQty">
                                </div>
                                <div class="col-6 text-nowrap">
                                    <p class="small  text-secondary mb-2"> {{  'batches.nbslLocation' | cxTranslate }}</p>
                                    <input id="nbslLoc" name="nbslLoc" formControlName="nbslLoc"  
                                    class="form-control custom_disabled_label">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-6 text-nowrap">
                                    <p class="small  text-secondary mb-2"> {{  'batches.nbsfLocation' | cxTranslate }}</p>
                                    <input id="nbsfLoc" name="nbsfLoc" formControlName="nbsfLoc" 
                                        class="form-control custom_disabled_label">
                                </div>
                                <div class="col-6 text-nowrap">
                                    <p class="small  text-secondary mb-2"> {{  'batches.NbsfNbllration' | cxTranslate }}</p>
                                    <input class="form-control custom_disabled_label" id="nbslNbsfRatio" name="nbslNbsfRatio" formControlName="nbslNbsfRatio">

                                </div>
                            </div>
                            <div class="row mt-3">     
                                <div class="col-12">
                                    <p class="small  text-secondary mb-2">{{  'batches.remark' | cxTranslate }} </p>
                                    <input id="screeningRemarks" name="screeningRemarks" formControlName="screeningRemarks" 
                                        class="form-control custom_disabled_label">
                                </div>
                            </div>             
                         
                            <div class="d-flex mt-3 justify-content-end"  *ngIf="screeningFormTemp[i].editScreeningThisFlag==true ">
                                <button class="btn-primary border bold h-40 float-end"  (click)="saveScreeningRecord(form,i)"> {{  'batches.save' | cxTranslate }}</button>
                            </div>  
                            <div  *ngIf="screeningFormTemp[i].editScreeningThisFlag==false">
                                <hr>
                                <div class="row">
                                    <div class="  justify-content-between">
                                        <div class="col-3 text-nowrap px-3">
                                            <p id="entryDate" class="small text-secondary mb-2 "  name="entryDate" >{{  'batches.entryDate' | cxTranslate }}: {{screeningForm.controls.entryDate.value}}</p><!--<p ></p> -->
                                        </div>
                                        <div class="col-3 text-nowrap px-3">
                                            <p class="small  text-secondary mb-2" id="lastUpdatedOn" name="lastUpdatedOn" >{{  'batches.updatedOn' | cxTranslate }}: {{screeningForm.controls.lastUpdatedOn.value}}</p>
                                        </div>
                                        <div class="col-3 text-nowrap px-3">
                                            <p class="small  text-secondary mb-2" id="lastUpdatedBy" name="lastUpdatedBy" >{{  'batches.lastUpdatedBy' | cxTranslate }}: {{screeningForm.controls.lastUpdatedBy.value}}</p>
                                        </div>
                                    </div>
                                    <button class="btn btn-secondary border bold h-40"  [disabled]="batchesScreendetails.screeningCompleted == true" (click)="editScreeningRecord(screeningForm,i)">{{  'batches.edit' | cxTranslate }}</button>
                                </div>  
                            </div> 
                        </div>       
                    
                    </div>    
                </form>
                
             </div>
        </div>
    </div>
    <!--screening entries mobile  view end-->
</div>
</div>